import {
    COMPANY_GETONE_FAIL,
    COMPANY_GETONE_SUCCESS,
    COMPANY_UPSERT_SUCCESS,
    COMPANY_UPSERT_FAIL,
    SET_MESSAGE
  } from "./types";

import CompanyService from "../services/company.service";

export const getCompany = () => (dispatch) => {
    return CompanyService.getCompany().then(
      (data) => {
        dispatch({
          type: COMPANY_GETONE_SUCCESS,
          payload: {company: data},
        });
        return Promise.resolve();
      },
      (error) => {
        
        dispatch({ type: COMPANY_GETONE_FAIL });
        dispatch({
          type: SET_MESSAGE,
          payload: `Company retrieval failed : (${error})`,
        });
  
        return Promise.reject();
      }
    );
  };

  export const upsertCompany = (company) => (dispatch) => {
    return CompanyService.upsertCompany(company).then(
      (data) => {
        dispatch({ type: COMPANY_UPSERT_SUCCESS, payload: data });
        return Promise.resolve();
      },
      (error) => {
        dispatch({ type: COMPANY_UPSERT_FAIL });
        dispatch({
          type: SET_MESSAGE,
          payload: `Company upsert failed - ${error}`,
        });
        return Promise.reject();
      }
    );
  };

